export default __webpack_public_path__ + "static/media/193.a68cead7.jpg";